import {ChangeDetectionStrategy, Component} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {MatDialogRef} from "@angular/material/dialog";
import {AuthService} from "../../_services/auth.service";
import {SnackbarService} from "../../_services/snackbar.service";

@Component({
    selector: 'app-feedback',
    templateUrl: './feedback.component.html',
    styleUrl: './feedback.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FeedbackComponent {
    feedbackForm: FormGroup;
    loading: boolean = false;
    contactEmail: string | undefined;

    constructor(private formBuilder: FormBuilder,
                protected dialogRef: MatDialogRef<FeedbackComponent>,
                private authService: AuthService,
                private snackbarService: SnackbarService) {
        this.feedbackForm = this.formBuilder.group({
            title: ['', Validators.required],
            description: ['', Validators.required],
        });
        this.authService.getDynamicSettings().then((r): void => {
            this.contactEmail = r.contact_email;
        });
    }

    submit(): void {
        if (this.feedbackForm.invalid) {
            this.feedbackForm.markAllAsTouched();
            return;
        }
        this.loading = true;
        let mail: string = "mailto:"
        mail = mail + this.contactEmail;
        mail = mail + '?subject=' + this.feedbackForm.value.title;
        mail = mail + '&body=' + this.feedbackForm.value.description;
        location.href = mail;
        this.snackbarService.openSnackBar('Opening mail client to finish feedback submission', 'success')
        setTimeout((): void => {
            this.dialogRef.close();
        }, 500);


    }
}
